import { useSessionTenantOrigin } from "../hooks/useSessionTenantOrigin";
import { spaceGitPath } from "../lib/apiPaths";
import { CopyableValue } from "./Settings/CopyableValue";
import { SettingsCard, SettingsHeading } from "./SettingsCard";
import { Text } from "./Text";

export function SpaceGitUrl({ slug }: { slug: string | null }) {
  const tenantOrigin = useSessionTenantOrigin();
  if (!slug) return null;
  const url = `${tenantOrigin}${spaceGitPath(slug)}`;

  return (
    <SettingsCard>
      <SettingsHeading>
        <Text variant="text-regular-md">Git URL</Text>
        <Text variant="text-small" color="var(--text-secondary)">
          Clone this space as a git repository. Authenticate with an API key as
          the password.
        </Text>
      </SettingsHeading>
      <CopyableValue value={url}>
        <Text
          ellipsis
          variant="text-regular"
          color="var(--text-secondary)"
          style={{ flex: 1 }}
        >
          {url}
        </Text>
      </CopyableValue>
    </SettingsCard>
  );
}
